import { TSelectedFilters } from "@/interfaces/filters.interface";
import client from "@/utils/client";
import urlcat from "urlcat";

export const getSideFilters = (
  userId?: string,
  extraFilters?: TSelectedFilters
) => {
  const url = userId
    ? `/common/get-explore-filter/${userId}`
    : `/common/get-explore-filter`;

  const newUrl = extraFilters ? urlcat(url, extraFilters) : url;

  return client.get(newUrl);
};
